export const CR_ME_OPEN_PENDING_ID = '65f062bc2d71dfb4e188014a';
export const CR_ME_FULL_AGREEMENT_ID = '65f062bc2d71dfb4e1880141';
export const CR_ME_NO_AGREEMENT_ID = '65f062bc2d71dfb4e1880142';
export const CR_ME_PARTIAL_AGREEMENT_ID = '65f062bc2d71dfb4e1880143';
export const CR_ME_NO_CONTACT_ID = '65f062bc2d71dfb4e1880144';
export const CR_ME_TOO_FEW_PARTIES_ID = '65f062bc2d71dfb4e1880145';
export const CR_ME_CANCELED_NO_SHOW_ID = '65f062bc2d71dfb4e1880146';
export const CR_ME_DECLINED_ID = '65f062bc2d71dfb4e1880147';
export const CR_ME_WITHDRAWN_ID = '65f062bc2d71dfb4e1880148';
export const CR_ME_DISCONTINUED_ID = '65f062bc2d71dfb4e1880149';
export const CR_ME_INAPPROPRIATE_ID = '65f062bc2d71dfb4e1880150';
export const CR_ME_LIMITED_RESOURCES_MEDIATOR_ID = '65f062bc2d71dfb4e1880151';
export const CR_ME_LIMITED_RESOURCES_INTERPRETER_ID = '65f062bc2d71dfb4e1880152';
export const CR_ME_LIMITED_RESOURCES_TECHNOLOGY_ID = '65f062bc2d71dfb4e1880153';
export const CR_ME_LIMITED_RESOURCES_SPACE_ID = '65f062bc2d71dfb4e1880154';
export const CR_ME_LIMITED_RESOURCES_OTHER_ID = '65f062bc2d71dfb4e1880155';
export const CR_CO_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880156';
export const CR_CO_FULL_AGREEMENT_ID = '65f062bc2d71dfb4e1880157';

export const CR_CO_NO_AGREEMENT_ID = '65f062bc2d71dfb4e1880158';
export const CR_CO_PARTIAL_AGREEMENT_ID = '65f062bc2d71dfb4e1880159';
export const CR_CO_NO_CONTACT_ID = '65f062bc2d71dfb4e1880160';
export const CR_CO_TOO_FEW_PARTIES_ID = '65f062bc2d71dfb4e1880161';
export const CR_CO_CANCELLED_NO_SHOW_ID = '65f062bc2d71dfb4e1880162';
export const CR_CO_DECLINED_ID = '65f062bc2d71dfb4e1880163';
export const CR_CO_WITHDRAWN_ID = '65f062bc2d71dfb4e1880164';
export const CR_CO_DISCONTINUED_ID = '65f062bc2d71dfb4e1880165';
export const CR_CO_INAPPROPRIATE_ID = '65f062bc2d71dfb4e1880166';
export const CR_CO_LIMITED_RESOURCES_CONCILATOR_ID = '65f062bc2d71dfb4e1880167';
export const CR_CO_LIMITED_RESOURCES_INTERPRETER_ID = '65f062bc2d71dfb4e1880168';
export const CR_CO_LIMITED_RESOURCES_TECHNOLOGY_ID = '65f062bc2d71dfb4e1880169';

export const CR_CO_LIMITED_RESOURCES_SPACE_ID = '65f062bc2d71dfb4e1880170';
export const CR_CO_LIMITED_RESOURCES_OTHER_ID = '65f062bc2d71dfb4e1880171';
export const CR_FA_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880172';
export const CR_FA_COMPLETED_ID = '65f062bc2d71dfb4e1880173';
export const CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION_ID = '65f062bc2d71dfb4e1880174';
export const CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION_ID = '65f062bc2d71dfb4e1880175';
export const CR_CC_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880176';
export const CR_CC_COMPLETED_ID = '65f062bc2d71dfb4e1880177';
export const CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION_ID = '65f062bc2d71dfb4e1880178';
export const CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION_ID = '65f062bc2d71dfb4e1880179';

export const CR_CC_INAPPROPRIATE_ID = '65f062bc2d71dfb4e1880180';
export const CR_RPC_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880181';
export const CR_RPC_COMPLETED_ID = '65f062bc2d71dfb4e1880182';
export const CR_RPC_AGREEMENT_ID = '65f062bc2d71dfb4e1880183';
export const CR_RPC_NO_AGREEMENT_ID = '65f062bc2d71dfb4e1880184';
export const CR_RPC_PARTIAL_AGREEMENT_ID = '65f062bc2d71dfb4e1880185';
export const CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE_ID = '65f062bc2d71dfb4e1880186';
export const CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE_ID = '65f062bc2d71dfb4e1880187';
export const CR_DD_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880188';
export const CR_DD_COMPLETED_ID = '65f062bc2d71dfb4e1880189';

export const CR_DD_WITHDRAWN_ID = '65f062bc2d71dfb4e1880190';
export const CR_OTH_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880191';
export const CR_OTH_COMPLETED_ID = '65f062bc2d71dfb4e1880192';
export const CR_OTH_WITHDRAWN_ID = '65f062bc2d71dfb4e1880193';

export const TR_BM_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880194';
export const TR_BM_COMPLETED_ID = '65f062bc2d71dfb4e1880195';
export const TR_BM_OTHER_ID = '65f062bc2d71dfb4e1881205';

export const TR_PM_OPEN_PENDING_ID = '65f062bc2d71dfb4e1881196';
export const TR_PM_COMPLETED_ID = '65f062bc2d71dfb4e1880196';
export const TR_PM_OTHER_ID = '65f062bc2d71dfb4e1880197';

export const TR_RP_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880198';
export const TR_RP_COMPLETED_ID = '65f062bc2d71dfb4e1880199';

export const TR_RP_OTHER_ID = '65f062bc2d71dfb4e1880200';
export const TR_SBW_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880201';
export const TR_SBW_COMPLETED_ID = '65f062bc2d71dfb4e1880202';
export const TR_SBW_OTHER_ID = '65f062bc2d71dfb4e1880203';
export const TR_AT_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880204';
export const TR_AT_COMPLETED_ID = '65f062bc2d71dfb4e1880205';

export const TR_AT_OTHER_ID = '65f062bc2d71dfb4e1880206';

export const TR_CC_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880207';
export const TR_CC_COMPLETED_ID = '65f062bc2d71dfb4e1880208';
export const TR_CC_OTHER_ID = '65f062bc2d71dfb4e1880209';

export const TR_OTH_OPEN_PENDING_ID = '65f062bc2d71dfb4e1881207';
export const TR_OTH_COMPLETED_ID = '65f062bc2d71dfb4e1881208';
export const TR_OTH_OTHER_ID = '65f062bc2d71dfb4e1881209';

export const OUT_RE_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880210';
export const OUT_RE_COMPLETED_ID = '65f062bc2d71dfb4e1880211';
export const OUT_RE_CANCELED_ID = '65f062bc2d71dfb4e1880212';
export const OUT_OTH_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880213';
export const OUT_OTH_COMPLETED_ID = '65f062bc2d71dfb4e1880214';
export const OUT_OTH_CANCELLED_ID = '65f062bc2d71dfb4e1880215';
export const OUT_OTH_OTHER_ID = '65f062bc2d71dfb4e1880216';
export const VSM_MEN_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880217';
export const VSM_MEN_COMPLETED_ID = '65f062bc2d71dfb4e1880218';
export const VSM_MEN_CANCELLED_ID = '65f062bc2d71dfb4e1880219';

export const VSM_EVA_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880220';
export const VSM_EVA_COMPLETED_ID = '65f062bc2d71dfb4e1880221';
export const VSM_EVA_CANCELLED_ID = '65f062bc2d71dfb4e1880222';
export const VSM_OTH_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880223';
export const VSM_OTH_COMPLETED_ID = '65f062bc2d71dfb4e1880224';
export const VSM_OTH_OTHER_ID = '65f062bc2d71dfb4e1880225';
export const OE_BM_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880226';
export const OE_BM_CANCELLED_ID = '65f062bc2d71dfb4e1880227';
export const OE_AM_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880228';
export const OE_AM_COMPLETED_ID = '65f062bc2d71dfb4e1880229';

export const OE_AM_CANCELLED_ID = '65f062bc2d71dfb4e1880230';
export const OE_CM_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880231';
export const OE_CM_COMPLETED_ID = '65f062bc2d71dfb4e1880232';
export const OE_CM_CANCELLED_ID = '65f062bc2d71dfb4e1880233';
export const OE_SP_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880234';
export const OE_SP_COMPLETED_ID = '65f062bc2d71dfb4e1880235';
export const OE_SP_CANCELLED_ID = '65f062bc2d71dfb4e1880236';
export const OE_EV_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880237';
export const OE_EV_COMPLETED_ID = '65f062bc2d71dfb4e1880238';
export const OE_EV_CANCELLED_ID = '65f062bc2d71dfb4e1880239';

export const OE_OTH_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880240';
export const OE_OTH_COMPLETED_ID = '65f062bc2d71dfb4e1880241';
export const OE_OTH_OTHER_ID = '65f062bc2d71dfb4e1880242';
export const ON_OTH_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880243';
export const ON_OTH_ATTENDED_ID = '65f062bc2d71dfb4e1880244';
export const ON_OTH_OTHER_ID = '65f062bc2d71dfb4e1880245';
export const OD_GW_INPROCESS_ID = '65f062bc2d71dfb4e1880246';
export const OD_GW_SUBMITTED_ID = '65f062bc2d71dfb4e1880247';
export const OD_GW_ACCEPTED_ID = '65f062bc2d71dfb4e1880248';
export const OD_GW_REJECTED_ID = '65f062bc2d71dfb4e1880249';

export const OD_GR_ONGOING_ID = '65f062bc2d71dfb4e1880250';
export const OD_GR_COMPLETED_ID = '65f062bc2d71dfb4e1880251';
export const OD_GM_ONGOING_ID = '65f062bc2d71dfb4e1880252';
export const OD_GM_CLOSED_ID = '65f062bc2d71dfb4e1880253';
export const OD_FR_PLANNING_ID = '65f062bc2d71dfb4e1880254';
export const OD_FR_ONGOING_ID = '65f062bc2d71dfb4e1880255';
export const OD_FR_CLOSED_ID = '65f062bc2d71dfb4e1880256';
export const OD_OTH_ONGOING_ID = '65f062bc2d71dfb4e1880257';
export const OD_OTH_CLOSED_ID = '65f062bc2d71dfb4e1880258';
export const OD_OTH_OTHER_ID = '65f062bc2d71dfb4e1880259';

export const ME_PMPQM_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880260';
export const ME_PMPQM_COMPLETED_ID = '65f062bc2d71dfb4e1880261';
export const ME_PMPQM_CANCELLED_ID = '65f062bc2d71dfb4e1880262';
export const OT_OT_OPEN_PENDING_ID = '65f062bc2d71dfb4e1880263';
export const OT_OT_COMPLETED_ID = '65f062bc2d71dfb4e1880264';
export const OT_OT_OTHER_ID = '65f062bc2d71dfb4e1880265';
export const OE_BM_COMPLETED_ID = '65f062bc2d71dfb4e1880266';

export const ON_OTH_OPEN_PENDING = {
    _id: ON_OTH_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const ON_OTH_ATTENDED = {
    _id: ON_OTH_ATTENDED_ID,
    label: 'Attended',
    description: 'Attended organizational networking event',
    closed: true,
    errorMessage: '',
};

export const ON_OTH_OTHER = {
    _id: ON_OTH_OTHER_ID,
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const OE_AM_OPEN_PENDING = {
    _id: OE_AM_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_AM_COMPLETED = {
    _id: OE_AM_COMPLETED_ID,
    label: 'Completed',
    description: 'Annual meeting has been held',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed meeting action to select this disposition.',
};

export const OE_AM_CANCELLED = {
    _id: OE_AM_CANCELLED_ID,
    label: 'Canceled',
    description: 'Annual meeting was canceled',
    closed: true,
    errorMessage: '.',
};

export const OE_BM_OPEN_PENDING = {
    _id: OE_BM_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_BM_COMPLETED = {
    _id: OE_BM_COMPLETED_ID,
    label: 'Completed',
    description: 'Board meeting has been held',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed meeting action to select this disposition.',
};

export const OE_BM_CANCELLED = {
    _id: OE_BM_CANCELLED_ID,
    label: 'Canceled',
    description: 'Board meeting was canceled',
    closed: true,
    errorMessage: '',
};

export const OE_CM_OPEN_PENDING = {
    _id: OE_CM_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '.',
};

export const OE_CM_COMPLETED = {
    _id: OE_CM_COMPLETED_ID,
    label: 'Completed',
    description: 'Committee meeting has been held',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed meeting action to select this disposition.',
};
export const OE_CM_CANCELLED = {
    _id: OE_CM_CANCELLED_ID,
    label: 'Canceled',
    description: 'Committee meeting was canceled',
    closed: true,
    errorMessage: '',
};

export const OE_SP_OPEN_PENDING = {
    _id: OE_SP_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_SP_COMPLETED = {
    _id: OE_SP_COMPLETED_ID,
    label: 'Completed',
    description: 'Strategic planning completed',
    closed: true,
    errorMessage: '',
};
export const OE_SP_CANCELLED = {
    _id: OE_SP_CANCELLED_ID,
    label: 'Canceled',
    description: 'Strategic planning canceled',
    closed: true,
    errorMessage: '',
};
export const OE_EV_OPEN_PENDING = {
    _id: OE_EV_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OE_EV_COMPLETED = {
    _id: OE_EV_COMPLETED_ID,
    label: 'Completed',
    description: 'Event completed',
    closed: true,
    errorMessage: '',
};
export const OE_EV_CANCELLED = {
    _id: OE_EV_CANCELLED_ID,
    label: 'Canceled',
    description: 'Event canceled',
    closed: true,
    errorMessage: '',
};
export const OE_OTH_OPEN_PENDING = {
    _id: OE_OTH_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_OTH_COMPLETED = {
    _id: OE_OTH_COMPLETED_ID,
    label: 'Completed',
    description: 'Event completed',
    closed: true,
    errorMessage: '',
};
export const OE_OTH_OTHER = {
    _id: OE_OTH_OTHER_ID,
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const OT_OT_OPEN_PENDING = {
    _id: OT_OT_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OT_OT_COMPLETED = {
    _id: OT_OT_COMPLETED_ID,
    label: 'Completed',
    description: 'Activity completed',
    closed: true,
    errorMessage: '',
};
export const OT_OT_OTHER = {
    _id: OT_OT_OTHER_ID,
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const OUT_RE_OPEN_PENDING = {
    _id: OUT_RE_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OUT_RE_COMPLETED = {
    _id: OUT_RE_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed Re-entry Info Session',
    closed: true,
    errorMessage: '',
};
export const OUT_RE_CANCELED = {
    _id: OUT_RE_CANCELED_ID,
    label: 'Canceled',
    description: 'Re-entry Info Session canceled',
    closed: true,
    errorMessage: '',
};

export const OUT_OTH_OPEN_PENDING = {
    _id: OUT_OTH_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OUT_OTH_COMPLETED = {
    _id: OUT_OTH_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed outreach',
    closed: true,
    errorMessage: '',
};

export const OUT_OTH_CANCELLED = {
    _id: OUT_OTH_CANCELLED_ID,
    label: 'Canceled',
    description: 'CMC or partnering entity canceled outreach',
    closed: true,
    errorMessage: '',
};

export const OUT_OTH_OTHER = {
    _id: OUT_OTH_OTHER_ID,
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const OD_GW_INPROCESS = {
    _id: OD_GW_INPROCESS_ID,
    label: 'In process',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OD_GW_SUBMITTED = {
    _id: OD_GW_SUBMITTED_ID,
    label: 'Submitted',
    description: 'Grant submitted',
    closed: true,
    errorMessage: '',
};

export const OD_GW_ACCEPTED = {
    _id: OD_GW_ACCEPTED_ID,
    label: 'Accepted',
    description: 'Grant accepted',
    closed: true,
    errorMessage: '',
};

export const OD_GW_REJECTED = {
    _id: OD_GW_REJECTED_ID,
    label: 'Rejected',
    description: 'Grant rejected',
    closed: true,
    errorMessage: '',
};

export const OD_GR_ONGOING = {
    _id: OD_GR_ONGOING_ID,
    label: 'Ongoing',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OD_GR_COMPLETED = {
    _id: OD_GR_COMPLETED_ID,
    label: 'Completed',
    description: 'Grant research completed',
    closed: true,
    errorMessage: '',
};
export const OD_GM_ONGOING = {
    _id: OD_GM_ONGOING_ID,
    label: 'Ongoing',
    description: 'Managing current grant',
    closed: false,
    errorMessage: '',
};

export const OD_GM_CLOSED = {
    _id: OD_GM_CLOSED_ID,
    label: 'Closed',
    description: 'Grant cycle closed',
    closed: true,
    errorMessage: '',
};

export const OD_FR_PLANNING = {
    _id: OD_FR_PLANNING_ID,
    label: 'Planning',
    description: 'Fundraising is in planning stage',
    closed: false,
    errorMessage: '',
};

export const OD_FR_ONGOING = {
    _id: OD_FR_ONGOING_ID,
    label: 'Ongoing',
    description: 'Fundraising activity has been launched and is in process',
    closed: false,
    errorMessage: '',
};

export const OD_FR_CLOSED = {
    _id: OD_FR_CLOSED_ID,
    label: 'Closed',
    description: '',
    closed: true,
    errorMessage: '',
};
export const OD_OTH_ONGOING = {
    _id: OD_OTH_ONGOING_ID,
    label: 'Ongoing',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OD_OTH_CLOSED = {
    _id: OD_OTH_CLOSED_ID,
    label: 'Closed',
    description: '',
    closed: true,
    errorMessage: '',
};
export const OD_OTH_OTHER = {
    _id: OD_OTH_OTHER_ID,
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

// Traninig
export const TR_BM_OPEN_PENDING = {
    _id: TR_BM_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_BM_COMPLETED = {
    _id: TR_BM_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};

export const TR_BM_OTHER = {
    _id: TR_BM_OTHER_ID,
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_PM_OPEN_PENDING = {
    _id: TR_PM_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_PM_COMPLETED = {
    _id: TR_PM_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_PM_OTHER = {
    _id: TR_PM_OTHER_ID,
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_RP_OPEN_PENDING = {
    _id: TR_RP_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const TR_RP_COMPLETED = {
    _id: TR_RP_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_RP_OTHER = {
    _id: TR_RP_OTHER_ID,
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_SBW_OPEN_PENDING = {
    _id: TR_SBW_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_SBW_COMPLETED = {
    _id: TR_SBW_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the workshop',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_SBW_OTHER = {
    _id: TR_SBW_OTHER_ID,
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};
export const TR_AT_OPEN_PENDING = {
    _id: TR_AT_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_AT_COMPLETED = {
    _id: TR_AT_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_AT_OTHER = {
    _id: TR_AT_OTHER_ID,
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};
export const TR_CC_OPEN_PENDING = {
    _id: TR_CC_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const TR_CC_COMPLETED = {
    _id: TR_CC_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};

export const TR_CC_OTHER = {
    _id: TR_CC_OTHER_ID,
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_OTH_OPEN_PENDING = {
    _id: TR_OTH_OPEN_PENDING_ID,
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const TR_OTH_COMPLETED = {
    _id: TR_OTH_COMPLETED_ID,
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};

export const TR_OTH_OTHER = {
    _id: TR_OTH_OTHER_ID,
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};
